import React from 'react';
import { Button } from 'antd';

const RunCodeButton = ({ theme, disabled, submitCode, loading = false }) => {
  return (
    <Button
      type="primary"
      disabled={disabled || loading}
      onClick={() => submitCode()}
      data-testid="run-code-button-footer"
      data-track="click"
      data-track-category="CodeEditor"
      data-track-label="run-code-button"
      ghost
      loading={loading}
      style={{
        border: disabled ? '1px solid #d9d9d9' : '1px solid var(--selector-marker)',
        width: '100px',
        height: '40px',
        margin: '0 8px',
        borderRadius: '2px',
      }}
    >
      Run Code
    </Button>
  );
};

export default RunCodeButton;
